import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Table, IconButton, Icon, ButtonGroup, Button, Row, Col } from 'rsuite'
import { initialNewData, getExpandedId, getNewDataEdit } from './SubProjectIncomeRecordUntils'
import EditSelectCell from '../../components/cell/EditSelectCell'
import EditTextCell from '../../components/cell/EditTextCell'
import EditNumberCell from '../../components/cell/EditNumberCell'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { budgetFormat } from '../../utils/formatterUtil'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
  hasMinValidator,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import moment from 'moment/moment'
import { LOCAL_DAY_TH } from '../../constants/date'
import { cloneDeep } from 'lodash-es'
import notification from '../../utils/notification'
import { v4 as uuidv4 } from 'uuid'

export default function SubProjectIncomeRecordTable({
  schema,
  loading,
  setValue,
  errors,
  register,
  control,
  getValues,
  isEnableEdit,
  isViewMode,
  ...props
}) {
  const { isReceiveAnnuity } = props
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])

  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)

  const [expenseTypeVal, setExpenseTypeVal] = useState(null)
  const [showModalExpenseFor, setShowModalExpenseFor] = useState(false)
  const [checkBoxList, setCheckBoxList] = useState([])
  const [masterTableData, setMasterTableData] = useState([])
  const _styleCellSummary = { backgroundColor: '#1f5581', color: '#fff', fontWeight: 'bold' }

  useEffect(() => {
    setTableData(schema.values)
    register('table', schema.values || [])
    setValue('table', schema.values || [])
  }, [schema.values])

  useEffect(() => {
    if (errors) {
      console.log('errors', errors)
      let key = Object.keys(errors)
      if (key.length > 0) {
        notification.open('error', {
          title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
          duration: 5000,
        })
      }
    }
  }, [errors])

  const handleOpenEditRow = (rowData) => {
    tableData.map((row) => {
      if (row.id == rowData.id) {
        const nextData = getNewDataEdit(tableData, row)
        setTableData(nextData)
      }
    })
  }

  const onDeleteRow = (rowData) => {
    let datas = cloneDeep(tableData)

    datas = datas.filter((e) => e.id != rowData.id)

    var sumObj = {}
    if (datas && datas?.length > 0) {
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0
      sumObj.withholding = 0
      sumObj.receivedAmount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        expenseList: '',
        expenseTotal: 0,
        isSummary: true,
      }
    }

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
      sumObj.withholding = sumObj.withholding + e.withholding
      sumObj.receivedAmount = sumObj.receivedAmount + e.receivedAmount
    })

    datas.push(sumObj)
    setTableData(datas)
    setValue('table', datas)
  }

  const handleOnClickAddNewData = () => {
    // setTableData()
    let datas = cloneDeep(tableData)

    //var lasted = datas[datas.length-1]
    var runnigNum = 1
    var sumObj = {}
    if (datas && datas?.length > 0) {
      runnigNum = datas.length - 1
      sumObj = datas[datas.length - 1]

      sumObj.amount = 0
      sumObj.withholding = 0
      sumObj.receivedAmount = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        expenseList: '',
        expenseTotal: 0,
        isSummary: true,
      }
    }

    var newObj = {
      id: 'addNew-' + runnigNum + '-' + uuidv4(),
      expenseList: '',
      expenseTotal: 0,
      isDeletable: true,
      status: 'EDIT',
    }

    datas.push(newObj)

    datas.forEach((e) => {
      sumObj.amount = sumObj.amount + e.amount
      sumObj.withholding = sumObj.withholding + e.withholding
      sumObj.receivedAmount = sumObj.receivedAmount + e.receivedAmount
    })

    datas.push(sumObj)

    console.log('datas : ', datas)

    setTableData(datas)
    setValue('table', datas)
  }

  const onChangeTableValue = (index, value, key) => {
    let datas = cloneDeep(tableData)
    datas[index].expenseTotal = value || 0

    setTableData(datas)
    setValue('table', datas)
  }

  const getTotalSummary = (_tableData) => {
    return _tableData.reduce((pre, cur) => {
      if (cur.expenseTotal && !cur.isSummary) {
        return pre + cur.expenseTotal
      }
      return pre
    }, 0)
  }

  return (
    <>
      <Table wordWrap autoHeight loading={loading} data={tableData} style={{ marginTop: '20px' }}>
        <Column width={120} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          {/* <CellRowNumber dataKey="id" /> */}
          <Cell>
            {(rowData, index) => {
              if (rowData.isSummary) {
                return ''
              }

              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={220} flexGrow={1}>
          <HeaderCell>รายการ</HeaderCell>
          {/* <CellExpenseList dataKey="expenseList" /> */}
          <Cell>
            {(rowData, index) => {
              if (rowData.isSummary) {
                return <b>{rowData.expenseList}</b>
              }

              return (
                <EditTextCell
                  id={`table[${index}].${schema.expenseList.name}`}
                  rowSchema={schema.expenseList}
                  rowData={rowData}
                  dataKey={schema.expenseList.name}
                  register={register}
                  control={control}
                  errors={errors}
                  isRequired={true}
                  isBudgetFormat={true}
                  disabled={!isEnableEdit || isReceiveAnnuity}
                />
              )
            }}
          </Cell>
        </Column>

        <Column width={200} align="right">
          <HeaderCell>ยอดรวม</HeaderCell>
          {/* <CellExpenseTotal dataKey="expenseTotal" /> */}
          <Cell align="right">
            {(rowData, index) => {
              if (rowData.isSummary) {
                // return <b>{budgetFormat(rowData.expenseTotal)}</b>
                return (
                  <span className={'cost-total-summary'}>
                    {`${budgetFormat(getTotalSummary(tableData))}`}
                  </span>
                )
              }

              return (
                <EditNumberCell
                  id={`table[${index}].${schema.expenseTotal.name}`}
                  rowData={rowData}
                  dataKey={schema.expenseTotal.name}
                  register={register}
                  control={control}
                  errors={errors}
                  isRequired={true}
                  isBudgetFormat={true}
                  disabled={!isEnableEdit || isReceiveAnnuity}
                  styleSheet={{ marginTop: 8, textAlign: 'right' }}
                  onChangeCell={(value) => {
                    onChangeTableValue(index, value)
                  }}
                  allowNegative={!hasMinValidator(schema.expenseTotal.validators)}
                />
              )
            }}
          </Cell>
        </Column>

        {!isViewMode && (
          <Column width={200} align="center" fixed="right">
            <HeaderCell>จัดการรายการ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (index == tableData.length - 1) {
                  return (
                    <>
                      {!isReceiveAnnuity && (
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
                          onClick={handleOnClickAddNewData}
                          // disabled={disabledButton}
                          style={{ marginLeft: 5 }}
                        >
                          {'เพิ่มรายการ'}
                        </IconButton>
                      )}
                    </>
                  )
                }

                if (rowData.isSummary) {
                  return ''
                }

                return (
                  <>
                    {rowData.id?.indexOf('addNew') == -1 && (
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={
                          <Icon
                            icon={rowData.status == 'EDIT' ? 'close' : 'edit'}
                            className="bt-gost-icon-radius-edit"
                          />
                        }
                        onClick={() => handleOpenEditRow(rowData)}
                        // disabled={!isEnableEdit}
                        size="sm"
                      >
                        {rowData.status == 'EDIT' ? 'ยกเลิก' : 'แก้ไข'}
                      </IconButton>
                    )}
                    {!isReceiveAnnuity && (
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={() => {
                          onDeleteRow(rowData)
                        }}
                        size="sm"
                        style={{ marginLeft: 5 }}
                      >
                        ลบ
                      </IconButton>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>
        )}
      </Table>

      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        // onConfirm={handleOnConfirmDelete}
      />

      {/* )} */}
    </>
  )
}
